module.exports = __webpack_public_path__ + "img/SU.49469845.png";